// @flow
import { CATEGORIES } from 'pages/MyAccount/services/actions/categoriesActions';
import type { Action } from 'pages/MyAccount/services/actions/Action.type';
import type { Category } from '../../sharedTypes';

export type CategoriesState = {|
  +categories: Array<Category>,
|};

export const categoriesInitialState = {
  categories: [],
};

export function categoriesReducer(
  state: CategoriesState = categoriesInitialState,
  action: Action
): CategoriesState {
  switch (action.type) {
    case CATEGORIES.RECEIVE_CATEGORIES: {
      const { categories } = action;
      return {
        ...state,
        categories,
      };
    }

    default: {
      return state;
    }
  }
}

// these categories are always displayed
export const staticCategories: Array<Category> = [
  {
    id: null,
    name: 'All',
    children: [],
  },
  {
    id: 'mycart',
    name: 'My Cart',
    children: [],
  },
  {
    id: 'myfavorites',
    name: 'My Favorites',
    children: [],
  },
];
